import React from "react";
import "./UsersPage.css";
import Table from "../../components/Table/Table";
import Flex from "../../components/Flex/Flex";
import { useDispatch, useSelector } from "react-redux";
import { activateUser, loadUsers } from "./reducer";
import {
  selectCurrentPage,
  selectPageSize,
  selectTotal,
  selectUsers,
} from "./selectors";
import { useIsAdmin } from "../../hooks/useIsAdmin";
import Text from "../../components/Text/Text";
import dayjs from "dayjs";
import { Link } from "react-router-dom";
import Button from "../../components/Button/Button";

const UsersPage = React.memo(() => {
  useIsAdmin();

  const dispatch = useDispatch();
  const total = useSelector(selectTotal);
  const users = useSelector(selectUsers);
  const pageSize = useSelector(selectPageSize);
  const currentPage = useSelector(selectCurrentPage);

  React.useEffect(() => {
    dispatch(loadUsers({ pageSize, page: 1 }));
  }, [dispatch, pageSize]);

  const handleChangePage = React.useCallback(
    (page: number, pageSize: number) => {
      dispatch(loadUsers({ pageSize, page }));
    },
    [dispatch]
  );

  const handleActivateUser = React.useCallback(
    (id: number) => {
      dispatch(activateUser(id));
    },
    [dispatch]
  );

  if (!users || !total) {
    return null;
  }

  return (
    <Flex
      className="UsersPage"
      vertical
      align="center"
      justify="center"
    >
      <Table
        columns={[
          {
            title: "Id",
            dataIndex: "id",
          },
          {
            title: "Email",
            dataIndex: "email",
            render: x => <Link to={`/users/${x.id}`}>{x.email}</Link>,
          },
          {
            title: "Подтвержден",
            dataIndex: "isConfirmed",
            render: x => <Text>{x.isConfirmed ? "Да" : "Нет"}</Text>,
          },
          {
            title: "Админ",
            dataIndex: "isAdmin",
            render: x => <Text>{x.isAdmin ? "Да" : "Нет"}</Text>,
          },
          {
            title: "Дата последнего поиска",
            dataIndex: "last_search_date",
            render: x => (
              <Text>
                {x.last_search_date
                  ? dayjs(x.last_search_date).format("YYYY-MM-DD HH:mm")
                  : "-"}
              </Text>
            ),
          },
          {
            title: "",
            dataIndex: "actions",
            render: x =>
              !x.isConfirmed ? (
                <Button
                  className="UsersPage__Activate-button"
                  type="primary"
                  onClick={() => handleActivateUser(x.id)}
                >
                  Активировать
                </Button>
              ) : null,
          },
        ]}
        data={users}
        pagination={{
          pageSize,
          currentPage,
          total,
          onChange: handleChangePage,
        }}
      />
    </Flex>
  );
});

export default UsersPage;
